import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import InvoicesList from './components/InvoicesList'
import InvoiceShow from './components/InvoiceShow'

import InvoiceCreate from './components/InvoiceCreate'

function App() {
  return (
    <>
      <nav className="navbar navbar-expand-md mb-4 border-bottom">
        <div className="container">
          <a className="navbar-brand" href="/">
            Xavier's invoices
          </a>
        </div>
      </nav>
      <div className="container">
        <div className="row">
          <Router>
            <Routes>
              <Route path="/invoice/new" Component={InvoiceCreate} />
              <Route path="/invoice/:id" Component={InvoiceShow} />
              <Route path="/" Component={InvoicesList} />
            </Routes>
          </Router>
        </div>
      </div>
    </>
  )
}

export default App
